import { useState } from "react";

export default function ShareBar({ title }: { title: string }) {
  const [toast, setToast] = useState("");
  const [open, setOpen] = useState(false);

  const showToast = (msg: string) => {
    setToast(msg);
    window.setTimeout(() => setToast(""), 2200);
  };

  const copyLink = async () => {
    const url = window.location.href;
    try {
      await navigator.clipboard.writeText(url);
      showToast("链接已复制到剪贴板");
    } catch {
      showToast("复制失败，请手动复制地址栏链接");
    }
    setOpen(false);
  };

  const nativeShare = async () => {
    setOpen(false);
    if (navigator.share) {
      try {
        await navigator.share({ title, text: `推荐一部影视作品：${title}`, url: window.location.href });
      } catch {
        /* user cancelled */
      }
    } else {
      showToast("当前浏览器不支持系统分享，已为你复制链接");
      copyLink();
    }
  };

  return (
    <div className="relative">
      <div className="flex items-center gap-3">
        <button
          type="button"
          onClick={copyLink}
          className="h-10 px-4 rounded-md border border-background-300 text-sm text-foreground-700 flex items-center gap-2 hover:border-primary-400 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-link"></i>
          复制链接
        </button>
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-label="分享"
          className="w-10 h-10 rounded-md bg-secondary-100 text-secondary-900 flex items-center justify-center hover:bg-secondary-200 transition-colors cursor-pointer"
        >
          <i className="ri-share-forward-line text-lg"></i>
        </button>
      </div>

      {open && (
        <div className="absolute z-30 mt-2 left-0 w-56 rounded-lg border border-background-200 bg-background-50 p-2 animate-fade-in">
          <button
            type="button"
            onClick={nativeShare}
            className="w-full px-3 py-2.5 rounded-md text-sm text-foreground-700 flex items-center gap-3 hover:bg-background-100 transition-colors cursor-pointer"
          >
            <i className="ri-share-line text-primary-500"></i>
            系统分享
          </button>
          <button
            type="button"
            onClick={copyLink}
            className="w-full px-3 py-2.5 rounded-md text-sm text-foreground-700 flex items-center gap-3 hover:bg-background-100 transition-colors cursor-pointer"
          >
            <i className="ri-file-copy-line text-primary-500"></i>
            复制链接地址
          </button>
          {["微博", "微信", "豆瓣"].map((name) => (
            <button
              key={name}
              type="button"
              onClick={() => {
                showToast(`已引导跳转 ${name} 分享（演示）`);
                setOpen(false);
              }}
              className="w-full px-3 py-2.5 rounded-md text-sm text-foreground-700 flex items-center gap-3 hover:bg-background-100 transition-colors cursor-pointer"
            >
              <i className="ri-share-circle-line text-accent-500"></i>
              分享到{name}
            </button>
          ))}
        </div>
      )}

      {toast && (
        <div className="fixed bottom-8 left-1/2 -translate-x-1/2 z-50 px-4 py-2.5 rounded-md bg-foreground-950 text-foreground-50 text-sm animate-fade-in">
          {toast}
        </div>
      )}
    </div>
  );
}